/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import EmbedBuilderFieldItemEdit from "./edit-item";

const EmbedBuilderFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <EmbedBuilderFieldItemEdit />
        </FieldListEditWrapper>
    );
};
EmbedBuilderFieldEdit.displayName = "EmbedBuilderFieldEdit";
export { EmbedBuilderFieldEdit };
